<div class="etoro-div">
    <section id="eToro" class="section section-etoro bg_trans section-padding gray-bg ">
        <div class="container">
            <div class="row row-etoro align-items-center justify-content-between">
                <div class="left-etoro col-xl-5 col-lg-5">
                    <div class="left-etoro-wrap">
                        <div class="etoro-img wow fadeInLeft" data-wow-delay=".2s">
                            <img src="assets/img/algorithmworks.jpg" alt="Backseat Trader">
                        </div>
                        <div class="floating-etoro wow fadeInLeft" data-wow-delay=".2s">
                            <img src="assets/img/logo-hd.png" alt="Backseat Trader">
                        </div>
                    </div>
                </div>
                <div class="right-etoro col-xl-5 col-lg-6 mt-5 mt-lg-0">
                    <div class="right-etoro-wrap fadeLeft">
                        <div class="section-title wow fadeInUp" data-wow-delay=".6s">
                            <h2>How the Backseat-Trader algorithm works</h2>
                        </div>
                        <div class="check-points wow fadeInUp" data-wow-delay=".7s">
                            <img src="assets/img/check.png" alt="Backseat-Trader algorithm works">
                            <p>It analyses all stock trading on the NASDAQ index</p>
                        </div>
                        <div class="check-points wow fadeInUp" data-wow-delay=".8s">
                            <img src="assets/img/check.png" alt="stock trading">
                            <p>From there it selects the Top 20 to trade on a monthly rotation</p>
                        </div>
                        <div class="check-points wow fadeInUp" data-wow-delay=".9s">
                            <img src="assets/img/check.png" alt="Backseat-Trader">
                            <p>Each month the algorithm updates the Top 20 for the coming month</p>
                        </div>
                        <div class="check-points wow fadeInUp" data-wow-delay="1s">
                            <img src="assets/img/check.png" alt="algorithm">
                            <p>Selecting the Top 20 provides diversification within the portfolio</p>
                        </div>
                        <div class="check-points wow fadeInUp" data-wow-delay="1.1s">
                            <img src="assets/img/check.png" alt="Backseat-Trader">
                            <p>This diversification reduces risk exposure whilst targeting a net-profit of 15 – 25%</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="bg__color section_wrapper">
        <div class="container">
            <div class="row wow fadeInUp" data-wow-delay=".2s">
                <div class="col-md">
                    <div class="note">
                        <h3 class="heading">You can view the current performance of Backseat-Trader by visiting its trading user account on eToro -</h3>
                    </div>
                </div>
                <div class="col-md-auto">
                <a href="https://www.etoro.com/people/cosmicetoro/stats" target="_blank" class="btn theme-btn animate hoverclr">cosmicetoro</a>
                </div>
            </div>
        </div>
    </section>

    <section class="etoro__links grey_bg_color">
        <div class="container"> 
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="section-title fadeUp">
                        <h2 class="wow fadeInUp" data-wow-delay=".4s">Other important links - About eToro</h2>
                    </div>
                </div>

                <div class="col-lg-4 col-12 offset-md-2 offset-lg-2">
                    <div class="featuresBox wow fadeInUp" data-wow-delay=".6s" style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                        <div class="note_icon">
                            <i class="fa fa-book" aria-hidden="true"></i>
                        </div>
                        <div class="content mt-4">
                            <p>The story behind the world's leading social trading platform</p>
                            <div class="btnBox mt-4 wow fadeInUp" data-wow-delay=".6s" style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                                <a href="https://www.etoro.com/about/" target="_blank" class="btn theme-btn hoverclr animate">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="featuresBox wow fadeInUp" data-wow-delay=".6s" style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">
                        <div class="cam_icon">
                        <i class="fa fa-id-card-o" aria-hidden="true"></i>
                        </div>
                        <div class="content mt-4">
                            <p>Regulation and License <br>&nbsp;</p>
                            <div class="btnBox mt-4 wow fadeInUp" data-wow-delay=".6s" style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                                <a href="https://www.etoro.com/customer-service/regulation-license/" target="_blank" class="btn theme-btn hoverclr animate">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section refer_withFriend">
        <div class="container">
            <div class="row text-align-center">
                <div class="col-md-12">
                    <div class="section-title fadeUp">
                        <h2 class="wow fadeInUp" data-wow-delay=".2s">Refer a Friend</h2>
                    <p class="margin-auto wow fadeInUp" data-wow-delay=".4s">You can inform someone you know about the Backseat-Trader algorithm.</p>
                    </div>
                    <div class="btnBox mt-5 wow fadeInUp" data-wow-delay=".6s">
                    <ng-template #content let-modal>
                        <div class="modal-header">
                          <h4 class="modal-title" id="modal-basic-title">Refer a Friend</h4>
                          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <form>
                            <div class="form-group">
                              <label for="fname_referer">Name</label>
                              <div class="input-group">
                                <input type="text" class="form-control" name="fname_referer" id="fname_referer" aria-describedby="firstName" placeholder="Your name..." (input)="yourName=$event.target.value">
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="email_referer">Email</label>
                              <div class="input-group">
                                <input type="email" class="form-control" name="email_referer" id="email_referer" aria-describedby="emailHelp" placeholder="Your email..." (input)="yourEmail=$event.target.value">
                            </div>
                            </div>
                            <div class="form-group">
                                <label for="friend_name">Friend's name</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" name="friend_name" id="friend_name" placeholder="Enter friend's name..." (input)="friendsName=$event.target.value">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="friend_email">Friend's email</label>
                                <div class="input-group">
                                    <input type="email" class="form-control" name="friend_email" id="friend_email" aria-describedby="emailHelp" placeholder="Enter friend's email..." (input)="friendsEmail=$event.target.value">
                                </div>
                            </div>
                          </form>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Submit</button>
                        </div>
                      </ng-template>
                      
                      <button class="btn theme-btn animate btn2" (click)="open(content)">REFER NOW</button>
                      
                    </div> 
                </div>
            </div>
        </div>
    </section>
</div>

<div class="modal fade referQues" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body">
                <form action="" method="post" onsubmit="">
                    <div class="form-header">
                        <h2>Refer a Friend</h2>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" name="fname_referer" id="fname_referer" aria-describedby="firstName" placeholder="Your name">
                    </div>
                    <div class="form-group">
                        <input type="email" class="form-control" name="email_referer" id="email_referer" aria-describedby="emailHelp" placeholder="Your email">
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" name="friend_name" id="friend_name" placeholder="Enter friend's name">
                    </div>
                    <div class="form-group">
                        <input type="email" class="form-control" name="friend_email" id="friend_email" aria-describedby="emailHelp" placeholder="Enter friend's email">
                    </div>
                    <div class="submit-btn">
                        <button type="submit" name="refer_submit" class="btn theme-btn animate hoverclr">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>